import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/* eslint-disable no-nested-ternary */

/* eslint-disable no-unused-vars */

/* eslint-disable array-callback-return */

/* eslint-disable react/no-array-index-key */

/* eslint-disable jsx-a11y/alt-text */

/* eslint-disable no-restricted-syntax */


import React, { useEffect, useState } from "react";
import { Input, Button, message } from "antd";
import "./index.less"; // eslint-disable-next-line no-unused-vars

import EvaluationQuestion from "./evaluation-comp/evaluation-question";
import EvaluationNps from "./evaluation-comp/evaluation-nps";
import { getEvaluationListTask, getEvaluationResultTask, saveEvalutionTask, saveOhterEvalutionTask } from "./api"; // import testJson from './test.json';
// import testJsonReadly from './test2.json';

var version = "体验监测V1.0";
var SUBMIT_IMG = "http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202204/20/eff59_20220420101338.png";
var TextArea = Input.TextArea;
export var SceneInfo;

(function (SceneInfo) {
  SceneInfo[SceneInfo["homePage"] = 1] = "homePage";
  SceneInfo[SceneInfo["liveCourse"] = 2] = "liveCourse";
  SceneInfo[SceneInfo["videoCourse"] = 3] = "videoCourse";
  SceneInfo[SceneInfo["ep3StudyPlan"] = 4] = "ep3StudyPlan";
  SceneInfo[SceneInfo["glive2StudyPlan"] = 5] = "glive2StudyPlan";
  SceneInfo[SceneInfo["ep3StudyReport"] = 6] = "ep3StudyReport";
  SceneInfo[SceneInfo["glive2StudyReport"] = 7] = "glive2StudyReport";
  SceneInfo[SceneInfo["note"] = 8] = "note";
  SceneInfo[SceneInfo["smartAnswer"] = 9] = "smartAnswer";
  SceneInfo[SceneInfo["personAnswer"] = 10] = "personAnswer";
  SceneInfo[SceneInfo["selfLive"] = 11] = "selfLive";
  SceneInfo[SceneInfo["selfFunction"] = 12] = "selfFunction";
  SceneInfo[SceneInfo["selfPhone"] = 13] = "selfPhone";
})(SceneInfo || (SceneInfo = {}));

var selectedMap = {};
var IS_SAVE = "EVALUATION_IS_SAVE";
export var GetQueryString = function GetQueryString(name) {
  var reg = new RegExp("(^|&)".concat(name, "=([^&]*)(&|$)"));
  var r = window.location.search.substr(1).match(reg); // search,查询？后面的参数，并匹配正则

  if (r != null) return unescape(r[2]);
  return null;
};
export var isIos = function isIos() {
  if (window.navigator.userAgent.toLowerCase().indexOf('gaodun') > -1 && window.navigator.userAgent.toLowerCase().indexOf('ios') > -1) {
    return true;
  }

  return false;
};
export var isAndroid = function isAndroid() {
  if (window.navigator.userAgent.toLowerCase().indexOf('gaodun') > -1 && window.navigator.userAgent.toLowerCase().indexOf('android') > -1) {
    return true;
  }

  return false;
};
export var isApp = function isApp() {
  if (navigator.userAgent.toLowerCase().includes('mobile')) {
    return true;
  }

  if (isAndroid() || isIos()) {
    return true;
  }

  return false;
};

var EvaluationPage = function EvaluationPage(props) {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      questionList = _useState2[0],
      setQuestionList = _useState2[1]; // 问题列表


  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      readQuestionList = _useState4[0],
      setReadQuestionList = _useState4[1]; // 问题列表


  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      textNum = _useState6[0],
      setTextNum = _useState6[1]; // 问题列表


  var _useState7 = useState(!!sessionStorage.getItem(IS_SAVE) || false),
      _useState8 = _slicedToArray(_useState7, 2),
      isSubmit = _useState8[0],
      setSubmit = _useState8[1]; // 问题列表


  var noEvaluate = /*#__PURE__*/React.createElement("div", {
    className: "to-appraise-wrapper"
  }, /*#__PURE__*/React.createElement("img", {
    className: "cry-appraise-img",
    src: "http://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202205/04/0f46b_20220504212850.png"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-wrapper"
  }, /*#__PURE__*/React.createElement("div", null, "\u60A8\u8FD8\u672A\u8BC4\u4EF7"), /*#__PURE__*/React.createElement("div", null, "\u5FEB\u6765\u5BF9\u8BFE\u7A0B\u8FDB\u884C\u8BC4\u4EF7\u5427\uFF01"), /*#__PURE__*/React.createElement(Button, {
    type: "link",
    onClick: function onClick() {
      return props.gotoEvaluation && props.gotoEvaluation();
    }
  }, "\u7ACB\u5373\u8BC4\u4EF7")));

  var getEvaluationList = function getEvaluationList() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var params, res, questionsList;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = {
                version: version,
                courseId: props.courseId,
                businessUnitId: props.businessUnitId,
                productType: props.productType
              };

              if (!location.host.includes('localhost')) {
                _context.next = 4;
                break;
              }

              _context.next = 7;
              break;

            case 4:
              _context.next = 6;
              return getEvaluationListTask(props.scene, params);

            case 6:
              res = _context.sent;

            case 7:
              if (res.status === 0) {
                // @ts-ignore
                questionsList = res.result.questions || [];
                questionsList.forEach(function (item) {
                  item.options && item.options.forEach(function (option) {
                    var parts = option.part || []; // 去除空的选项（后台逻辑比较麻烦，不好改，只有前端来改了）

                    if (parts && parts.length === 1) {
                      option.part = [];
                    }
                  });
                });
                setQuestionList(questionsList);
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  var getReadlyData = function getReadlyData() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _a, res;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getEvaluationResultTask({
                sceneId: props.scene,
                version: version,
                businessUnitId: props.businessUnitId,
                productType: props.productType // 类型：Number  必有字段  备注： 私教直播/私教功能传4 ，直播回放 精简5，实施6 大班课0

              });

            case 2:
              res = _context2.sent;

              if (res.status === 0) {
                // @ts-ignore
                setReadQuestionList((_a = res.result) === null || _a === void 0 ? void 0 : _a.studentEvaluationQuestionScoreList);
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  };

  var init = function init() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!props.isReadly) {
                _context3.next = 5;
                break;
              }

              _context3.next = 3;
              return getReadlyData();

            case 3:
              _context3.next = 7;
              break;

            case 5:
              _context3.next = 7;
              return getEvaluationList();

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  };

  useEffect(function () {
    init();
  }, []);

  var saveEval = function saveEval() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var isNotCompilt, remarkLenght100, evaluationContent, i, data, res;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              isNotCompilt = false;
              remarkLenght100 = false;
              questionList && questionList.map(function (item) {
                if (item.scoreStyle !== 0) {
                  var selectItem = selectedMap[item.questionId];
                  var selectOptions = item.options[selectItem.score - 1];

                  if (!selectItem) {
                    isNotCompilt = true; // 未完成
                  } else if (selectItem.score <= 3 && item.options && selectOptions.part && selectOptions.part.length > 0) {
                    if (!selectItem.optionPart || selectItem.optionPart.length <= 0) {
                      isNotCompilt = true; // 未完成
                    }

                    if (selectItem.optionPart && selectItem.optionPart.length > 0) {
                      selectItem.optionPart.map(function (op) {
                        op.remark && op.remark.length > 100 && (remarkLenght100 = true);
                      });
                    }
                  }
                }
              });

              if (!(JSON.stringify(selectedMap) === "{}")) {
                _context4.next = 6;
                break;
              }

              message.error("至少选择一个选项");
              return _context4.abrupt("return");

            case 6:
              if (!isNotCompilt) {
                _context4.next = 9;
                break;
              }

              message.error("至少选择一个选项");
              return _context4.abrupt("return");

            case 9:
              if (!remarkLenght100) {
                _context4.next = 11;
                break;
              }

              return _context4.abrupt("return", message.error("其他的内容不能大于100哦", 1));

            case 11:
              evaluationContent = []; // eslint-disable-next-line guard-for-in

              for (i in selectedMap) {
                evaluationContent.push(selectedMap[i]);
              }

              data = {
                evaluationType: props.evaluationType || 1,
                sceneId: props.scene || 11,
                // eslint-disable-next-line no-nested-ternary
                entrance: isApp() ? isIos() ? 2 : 3 : 1,
                productType: props.productType,
                businessUnitId: props.businessUnitId,
                deviceType: isApp() ? "APP" : "PC",
                version: version,
                evaluationContent: evaluationContent
              };
              res = null;

              if (!(data.sceneId === SceneInfo.selfFunction || data.sceneId === SceneInfo.selfLive || data.sceneId === SceneInfo.selfPhone)) {
                _context4.next = 21;
                break;
              }

              _context4.next = 18;
              return saveEvalutionTask(data);

            case 18:
              res = _context4.sent;
              _context4.next = 24;
              break;

            case 21:
              _context4.next = 23;
              return saveOhterEvalutionTask(data);

            case 23:
              res = _context4.sent;

            case 24:
              if (res.result && res.status === 0) {
                setSubmit(true);
                sessionStorage.setItem(IS_SAVE, "true");
                message.success("您的评价已提交~");
                setTimeout(function () {
                  props.onSubmit && props.onSubmit();
                }, 500);
              } else {
                message.error(res.message);
              }

            case 25:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  };

  var isReadlyView = function isReadlyView() {
    return /*#__PURE__*/React.createElement("div", {
      className: "container-read"
    }, readQuestionList ? readQuestionList.map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "container-content",
        key: JSON.stringify(item) + index
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, item.question)), item.score < 0 &&
      /*#__PURE__*/
      // <TextArea
      // 	disabled
      // 	value={item.appraise}
      // />
      React.createElement("div", {
        className: "content-remake"
      }, item.appraise), item.score > 0 && /*#__PURE__*/React.createElement(EvaluationQuestion, {
        key: JSON.stringify(item),
        readlyQuestionItem: item
      }));
    }) : noEvaluate);
  };

  var isEditView = function isEditView() {
    return /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, questionList ? questionList.map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "container-content",
        key: JSON.stringify(item) + index
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, item.question)), item.scoreStyle === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextArea, {
        placeholder: "\u4EB2\u7231\u7684\u540C\u5B66\uFF0C\u60A8\u5BF9\u672C\u6B21\u8BFE\u7A0B\u7684\u4F53\u9A8C\u5982\u4F55\uFF1F\u5E0C\u671B\u60A8\u5206\u4EAB\u611F\u53D7\u4E0E\u5EFA\u8BAE\uFF0C\u8BA9\u6211\u4EEC\u7684\u670D\u52A1\u66F4\u548C\u60A8\u7684\u5FC3\u610F~",
        rows: 2,
        maxLength: 100,
        onChange: function onChange(e) {
          var value = e.target.value;
          setTextNum(value.length || 0); // setTextaAre(`${value}`);

          selectedMap[item.questionId] = {
            questionId: item.questionId,
            appraise: value
          };
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "item-text-number"
      }, textNum, "/100")), item.scoreStyle === 1 && /*#__PURE__*/React.createElement(EvaluationNps, {
        onSelectedItem: function onSelectedItem(qitem) {
          selectedMap[qitem.questionId] = qitem;
        }
      }), item.scoreStyle === 2 && /*#__PURE__*/React.createElement(EvaluationQuestion, {
        firstClickIndex: props.firstClickIndex,
        questionItem: questionList[index],
        onSelectedItem: function onSelectedItem(qitem) {
          selectedMap[qitem.questionId] = qitem;
        }
      }));
    }) : noEvaluate);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "evaluation-root"
  }, isSubmit && props.isShowSuccessPage ? /*#__PURE__*/React.createElement("div", {
    className: "toast-bg"
  }, /*#__PURE__*/React.createElement("img", {
    className: "submit-img",
    src: SUBMIT_IMG,
    alt: ""
  }), /*#__PURE__*/React.createElement("strong", {
    className: "toast-title"
  }, "\u63D0\u4EA4\u6210\u529F"), /*#__PURE__*/React.createElement("div", {
    className: "toast-content"
  }, "\u611F\u8C22\u60A8\u7684\u8BC4\u4EF7\uFF0C\u6211\u4EEC\u5C06\u4ED4\u7EC6\u9605\u8BFB\u60A8\u7684\u8BC4\u4EF7"), /*#__PURE__*/React.createElement("div", {
    className: "toast-content"
  }, "\u63D0\u5347\u60A8\u7684\u4F7F\u7528\u4F53\u9A8C")) : props.isReadly ? isReadlyView() : isEditView(), /*#__PURE__*/React.createElement("div", {
    className: "eval-foot"
  }, props.footView, !props.isReadly && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bottom-line"
  }), /*#__PURE__*/React.createElement("div", {
    className: "submit-btn-eval",
    style: {
      justifyContent: props.buttonPosition || 'center'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    type: "primary",
    onClick: function onClick() {
      return saveEval();
    }
  }, "".concat(props.buttonText) || '提交')))));
};

export default EvaluationPage;